"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentWidgetMixin = void 0;
const CardName_1 = require("../CardName");
const ResourceType_1 = require("../ResourceType");
exports.PaymentWidgetMixin = {
    'name': 'PaymentWidgetMixin',
    'methods': {
        getMegaCreditsMax: function () {
            const $this = this;
            if ($this.$data.card !== undefined && $this.playerinput !== undefined && $this.playerinput.cards !== undefined) {
                const card = $this.playerinput.cards.find((card) => $this.$data.card.name === card.name);
                if (card !== undefined && card.mustSpendAtMost !== undefined) {
                    return card.mustSpendAtMost;
                }
            }
            return Math.min($this.player.megaCredits, $this.$data.cost);
        },
        getCssClassFor: function (action, target) {
            const currentValue = this[target];
            const maxValue = this.player[target];
            const disablingLimit = (action === '<') ? 0 : maxValue;
            if (currentValue === disablingLimit)
                return 'is-disabled';
            return 'is-primary';
        },
        getResourceRate: function (resourceName) {
            let rate = 1;
            if (resourceName === 'titanium') {
                rate = this.player.titaniumValue;
            }
            else if (resourceName === 'steel') {
                rate = this.player.steelValue;
            }
            else if (resourceName === 'microbes' || resourceName === 'spireScience') {
                rate = 2;
            }
            else if (resourceName === 'floaters' || resourceName === 'plants') {
                rate = 3;
            }
            else if (resourceName === 'graphene') {
                rate = 4;
            }
            return rate;
        },
        reduceValue: function (target, to) {
            const currentValue = this[target];
            if (currentValue === 0)
                return;
            const realTo = Math.min(to, currentValue);
            this[target] -= realTo;
            if (target === 'megaCredits' || realTo === 0)
                return;
            this.setRemainingMCValue();
        },
        addValue: function (target, to, max) {
            const currentValue = this[target];
            let maxValue = max !== null && max !== void 0 ? max : this.player[target];
            if (target === 'megaCredits') {
                maxValue = this.getMegaCreditsMax();
            }
            if (target === 'asteroids') {
                maxValue = this.availableAsteroids();
            }
            if (target === 'spireScience') {
                maxValue = this.availableSpireScience();
            }
            if (target === 'microbes') {
                maxValue = this.playerinput.microbes;
                if (this.isSoilEnrichmentEdgeCase())
                    maxValue--;
            }
            if (target === 'floaters') {
                maxValue = this.playerinput.floaters;
                if (this.isStratosphericBirdsEdgeCase())
                    maxValue--;
            }
            if (target === 'science')
                maxValue = this.playerinput.science;
            if (target === 'graphene')
                maxValue = this.playerinput.graphene;
            if (currentValue === maxValue)
                return;
            const realTo = (currentValue + to <= maxValue) ? to : maxValue - currentValue;
            this[target] += realTo;
            if (target === 'megaCredits' || realTo === 0)
                return;
            this.setRemainingMCValue();
        },
        setRemainingMCValue: function () {
            var _a, _b, _c;
            const remainingMC = this.$data.cost -
                this['heat'] -
                this['titanium'] * this.getResourceRate('titanium') -
                this['plants'] * this.getResourceRate('plants') -
                this['steel'] * this.getResourceRate('steel') -
                this['microbes'] * this.getResourceRate('microbes') -
                this['floaters'] * this.getResourceRate('floaters') -
                this['graphene'] * this.getResourceRate('graphene') -
                ((_a = this['asteroids']) !== null && _a !== void 0 ? _a : 0) -
                ((_b = this['spireScience']) !== null && _b !== void 0 ? _b : 0) * this.getResourceRate('spireScience') -
                ((_c = this['science']) !== null && _c !== void 0 ? _c : 0);
            this['megaCredits'] = Math.max(0, Math.min(this.getMegaCreditsMax(), remainingMC));
        },
        setMaxValue: function (target, max) {
            let currentValue = this[target];
            const cardCost = this.$data.cost;
            let amountHave = max !== null && max !== void 0 ? max : this.player[target];
            if (target === 'heat')
                amountHave = this.availableHeat();
            if (target === 'asteroids')
                amountHave = this.availableAsteroids();
            if (target === 'spireScience')
                amountHave = this.availableSpireScience();
            let amountNeed = cardCost;
            if (['titanium', 'steel', 'microbes', 'floaters', 'graphene', 'plants', 'spireScience'].includes(target)) {
                amountNeed = Math.floor(cardCost / this.getResourceRate(target));
            }
            if (target === 'microbes') {
                amountHave = this.playerinput.microbes;
                if (this.isSoilEnrichmentEdgeCase())
                    amountHave--;
            }
            if (target === 'floaters') {
                amountHave = this.playerinput.floaters;
                if (this.isStratosphericBirdsEdgeCase())
                    amountHave--;
            }
            if (target === 'science')
                amountHave = this.playerinput.science;
            if (target === 'graphene')
                amountHave = this.playerinput.graphene;
            while (currentValue < amountHave && currentValue < amountNeed) {
                this.addValue(target, 1, max);
                currentValue++;
            }
        },
        isSoilEnrichmentEdgeCase: function () {
            if (this.$data.card.name === CardName_1.CardName.SOIL_ENRICHMENT) {
                const playedCards = this.player.playedCards;
                const cardsWithMicrobes = playedCards.filter((card) => { var _a; return card.resourceType === ResourceType_1.ResourceType.MICROBE && ((_a = card.resources) !== null && _a !== void 0 ? _a : 0) > 0; });
                return cardsWithMicrobes.length === 1;
            }
            return false;
        },
        isStratosphericBirdsEdgeCase: function () {
            if (this.$data.card.name === CardName_1.CardName.STRATOSPHERIC_BIRDS) {
                const playedCards = this.player.playedCards;
                const cardsWithFloaters = playedCards.filter((card) => { var _a; return card.resourceType === ResourceType_1.ResourceType.FLOATER && ((_a = card.resources) !== null && _a !== void 0 ? _a : 0) > 0; });
                return cardsWithFloaters.length === 1;
            }
            return false;
        },
        availableAsteroids() {
            const thisPlayer = this.player;
            const corpCards = thisPlayer.corporationCards;
            const kuiperCooperative = corpCards.find((card) => card.name === CardName_1.CardName.KUIPER_COOPERATIVE);
            if (kuiperCooperative !== undefined && kuiperCooperative.resources !== undefined) {
                return kuiperCooperative.resources;
            }
            return 0;
        },
        availableSpireScience() {
            const thisPlayer = this.player;
            const corpCards = thisPlayer.corporationCards;
            const spire = corpCards.find((card) => card.name === CardName_1.CardName.SPIRE);
            if (spire !== undefined && spire.resources !== undefined) {
                return spire.resources;
            }
            return 0;
        },
        availableHeat() {
            const thisPlayer = this.player;
            const corpCards = thisPlayer.corporationCards;
            const stormcraft = corpCards.find((card) => card.name === CardName_1.CardName.STORMCRAFT_INCORPORATED);
            if (stormcraft !== undefined && stormcraft.resources !== undefined) {
                return thisPlayer['heat'] + (stormcraft.resources * 2);
            }
            return thisPlayer['heat'];
        },
    },
};
//# sourceMappingURL=PaymentWidgetMixin.js.map